import NumberFormat from 'react-currency-format';
import moment from 'moment';
import Select from 'react-select';

import { Checkbox } from '@material-ui/core';
import { FormGroup, Input, Label } from "reactstrap";
import { optionsContrats, optionsPropierty, optionsSituation } from "../../../../helper/constants";
import { isRUTValid } from '../../../../helper/functions';

const LaborData = ({ onChangeInput, values, isNew }) => (
  <div className='crm-case-form-container'>
    <div >
      <FormGroup>
        <Label className="label_autofin" for="companyName">Nombre empleador</Label>
        <Input
          type="text"
          name="companyName"
          id="companyName"
          maxLength="20"
          className="newArea"
          // disabled={values.editField}
          disabled={true}
          value={values.companyName}
          onChange={onChangeInput('companyName')}
        />
      </FormGroup>
    </div>
    <div >
      <FormGroup style={{ textAlign: 'left' }}>
        <Label className="label_autofin" for="rut">Rut empleador:</Label>
        <Input
          type="text"
          name="rut"
          id="rut"
          className="newArea"
          disabled={true}
          value={values.companyRUT}
          invalid={!isRUTValid(values.companyRUT)}
          onChange={onChangeInput('companyRUT')}
        />
      </FormGroup>
    </div>
    <div >
      <FormGroup style={{ textAlign: 'left' }}>
        <Label className="label_autofin" for="rent">Renta:</Label>
        <NumberFormat
          style={{ border: '1px solid #ced4da', borderRadius: '0.25rem' }}
          prefix="$"
          min="0"
          name="rent"
          id="rent"
          max="99999999"
          className="newArea"
          decimalSeparator=","
          thousandSeparator="."
          value={values.rent}
          disabled={true}
          onChange={onChangeInput('rent')}
        />
      </FormGroup>
    </div>
    {/* <div >
                        <FormGroup>
                          <Label className="label_autofin" for="rentType">Tipo Renta:</Label>
                          <Select
                            options={optionsRent}
                            type="text"
                            placeholder="seleccione"
                            name="rentType"
                            id="rentType"
                            value={values.rentType}
                            isDisabled={values.editField}
                            // isDisabled={typesOptionsFindIt}
                            onChange={onChangeInput('rentType')}
                            required
                          />
                        </FormGroup>
                      </div> */}
    <div >
      <FormGroup className="columend_date">
        <Label className="label_autofin" for="dateEntry">Fecha de ingreso:</Label>
        <Input
          type="text"
          name="dateEntry"
          id="dateEntry"
          maxLength="10"
          className="newArea"
          disabled={true}
          value={values.dateEntry && moment(values.dateEntry).format('DD/MM/YYYY')}
          onChange={onChangeInput('dateEntry')}
        />
      </FormGroup>
    </div>
    <div >
      <FormGroup>
        <Label className="label_autofin" for="workSituation">*Situación Laboral:</Label>
        <Select
          options={optionsSituation}
          type="text"
          placeholder="seleccione"
          name="workSituation"
          id="workSituation"
          value={values.workSituation}
          isDisabled={!isNew}
          // isDisabled={typesOptionsFindIt}
          onChange={onChangeInput('workSituation')}
          required
        />
      </FormGroup>
    </div>
    {
      ((values.workSituation) && (values.workSituation.value === 'dependent')) && (
        <div >
          <FormGroup>
            <Label className="label_autofin" for="typeContract">Tipo contrato:</Label>
            <Select
              options={optionsContrats}
              type="text"
              placeholder="seleccione"
              name="typeContract"
              id="typeContract"
              value={values.typeContract}
              isDisabled={true}
              // isDisabled={typesOptionsFindIt}
              onChange={onChangeInput('typeContract')}
              required
            />
          </FormGroup>
        </div>
      )
    }
    <div >
      <FormGroup>
        <Label className="label_autofin" for="antiquity">Antigüedad</Label>
        <Input
          type="text"
          name="antiquity"
          id="antiquity"
          maxLength="3"
          className="newArea"
          disabled={values.editField}
          value={values.antiquity}
          onChange={onChangeInput('antiquity')}
        />
      </FormGroup>
    </div>
    <div >
      <FormGroup style={{ textAlign: 'left' }}>
        <Label className="label_autofin" for="fixedIncome">¿Ingreso fijo?</Label>
        <Select
          options={optionsPropierty}
          type="text"
          placeholder="seleccionar"
          name="fixedIncome"
          id="fixedIncome"
          isDisabled={values.editField}
          value={values.fixedIncome}
          onChange={onChangeInput('fixedIncome')}
        />
      </FormGroup>
    </div>
    <div >
      <FormGroup style={{ textAlign: 'left' }}>
        <Label className="label_autofin" for="variableIncome">¿Ingreso Variable?</Label>
        <Select
          options={optionsPropierty}
          type="text"
          placeholder="seleccionar"
          name="variableIncome"
          id="variableIncome"
          isDisabled={values.editField}
          value={values.variableIncome}
          onChange={onChangeInput('variableIncome')}
        />
      </FormGroup>
    </div>
    {
      ((values.origin) && (values.origin.value === 'web')) && (
        values.plan && (
          <div >
            <FormGroup>
              <Label className="label_autofin" for="plan">Plan</Label>
              <Input
                type="text"
                maxLength="300"
                minLength="30"
                name="plan"
                id="plan"
                className="newArea"
                disabled="true"
                value={values.plan || ''}
                onChange={onChangeInput('plan')}
              />
            </FormGroup>
          </div>
        )
      )
    }
    {
      ((values.origin) && (values.origin.value === 'web')) && (
        (values.fromSimulation !== false) && (
          <div >
            <FormGroup>
              <Label className="label_autofin" for="plan">Simulación:</Label>
              <Checkbox
                style={{ color: (values.fromSimulation !== false) ? '#C7AC43' : 'rgba(0, 0, 0, 0.54)' }}
                disabled="true"
                checked="true"
              // checked={values.fromSimulation}
              />
            </FormGroup>
          </div>
        )
      )
    }
    <div >
      <FormGroup>
        <Label className="label_autofin" for="averageIncome">Ingreso Promedio:</Label>
        <NumberFormat
          style={{ border: '1px solid #ced4da', borderRadius: '0.25rem' }}
          prefix="$"
          disabled={values.editField}
          min="0"
          name="averageIncome"
          id="averageIncome"
          max="99999999"
          className="newArea"
          decimalSeparator=","
          thousandSeparator="."
          value={values.averageIncome || ''}
          onChange={onChangeInput('averageIncome')}
        />
      </FormGroup>
    </div>
    {
      values.workSituation && (
        ((values.workSituation.value) && (values.workSituation.value === 'independent'))
        && (
          <div className="col-md-12">
            <FormGroup>
              <Label className="label_autofin" for="clientActivity">*Actividad del Cliente</Label>
              <Input
                type="textarea"
                maxLength="300"
                minLength="30"
                style={{ height: '100px' }}
                name="clientActivity"
                id="clientActivity"
                className="newArea"
                disabled={values.editField}
                value={values.clientActivity || ''}
                onChange={onChangeInput('clientActivity')}
              />
            </FormGroup>
          </div>
        )
      )
    }
  </div>
);

export default LaborData;